import React, { createContext, useContext } from 'react'

type FileUploadContextProps = {
  title: string,
  errorMessage?: string,
  isError: boolean,
  onPress?: () => void,
  testId: string,
}

type FileUploadProviderProps = {
  children: React.ReactNode,
  title: string,
  errorMessage?: string,
  onPress?: () => void,
  testId: string,
}

const FileUploadContext = createContext<FileUploadContextProps | undefined>(undefined)

export const useFileUpload = () => {
  const context = useContext(FileUploadContext)
  if (!context) throw new Error('useFileUpload must be used within a FileUploadContext')
  return context
}

export const FileUploadProvider: React.FC<FileUploadProviderProps> = ({
  children,
  title,
  errorMessage,
  onPress,
  testId,
}) => {
  return (
    <FileUploadContext.Provider value={{
      title,
      errorMessage: errorMessage,
      isError: !!errorMessage, 
      onPress,
      testId,
    }}>
      {children}
    </FileUploadContext.Provider>
  )
}
